import { BackgroundContext } from "../../../context/background.context";
import { jsx as _jsx } from "react/jsx-runtime";
export var BackgroundProvider = function BackgroundProvider(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/_jsx(BackgroundContext.Provider, {
    value: {
      className: className
    },
    children: children
  });
};